import { Head } from '@inertiajs/react'
import { useState } from 'react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import ConnectionForm from '@/frontend/pages/Dashboard/Workflows/ConnectionForm'
import ExecutionLookup from '@/frontend/pages/Dashboard/Workflows/ExecutionLookup'
import ExecutionTable from '@/frontend/pages/Dashboard/Workflows/ExecutionTable'
import PageActions from '@/frontend/pages/Dashboard/Workflows/PageActions'
import SummaryMetrics from '@/frontend/pages/Dashboard/Workflows/SummaryMetrics'
import TemporalPanel from '@/frontend/pages/Dashboard/Workflows/TemporalPanel'
import WorkerStatus from '@/frontend/pages/Dashboard/Workflows/WorkerStatus'
import WorkflowCatalog from '@/frontend/pages/Dashboard/Workflows/WorkflowCatalog'
import BlockState from '@/frontend/pages/Dashboard/Workflows/BlockState'
import useRefresh from '@/frontend/pages/Dashboard/Workflows/useRefresh'
import useOrganizationReset from '@/frontend/pages/Dashboard/Workflows/useOrganizationReset'
import { connectionNeedsRepair, scopedState } from '@/frontend/pages/Dashboard/Workflows/presentation'
import type { Props } from '@/frontend/pages/Dashboard/Workflows/types'

function Index(props: Props) {
  const { organization, connection, copy, filters, list_path, selection, query_execution_id, query_error, temporal_url } = props
  const resetting = useOrganizationReset(props)
  const tenant = resetting ? undefined : scopedState(props.tenant_state, props)
  const executions = resetting ? undefined : scopedState(props.execution_page, props)
  const summary = resetting ? undefined : scopedState(props.summary_state, props)
  const [catalogRevision, setCatalogRevision] = useState(0)
  const { refreshing, refresh } = useRefresh(`${organization.id}:${connection.tenant}:${selection}`, ['tenant_state', 'execution_page', 'summary_state'], selection)
  function refreshAll() { setCatalogRevision((revision) => revision + 1); refresh() }
  return <main className="mx-auto w-full max-w-[1000px] space-y-8 pb-10 pt-3 md:pt-6" aria-busy={refreshing || resetting}>
    <Head title={copy.title} />
    <header className="flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
      <div className="min-w-0 space-y-1.5"><h1 className="text-2xl font-semibold leading-[30px] tracking-tight">{copy.title}</h1>
        <p className="text-sm leading-5 text-muted-foreground">{copy.description.replace('%{organization}', organization.name)}</p>
      </div>
      {connection.configured && <div className="flex shrink-0 flex-wrap items-center gap-3"><WorkerStatus state={tenant} copy={copy} /><PageActions refreshing={refreshing || resetting} refresh={refreshAll} url={null} copy={copy} /></div>}
    </header>
    {refreshing && <p role="status" className="text-sm text-muted-foreground">{copy.refreshing}</p>}
    {connectionNeedsRepair(props) && <ConnectionForm key={`${organization.id}:${connection.tenant ?? ''}`} tenant={connection.tenant} copy={copy} configurationPath={connection.configuration_path} />}
    {query_error && <BlockState error={query_error} copy={copy} />}
    {connection.configured && !query_error && filters && !resetting && <>
      <SummaryMetrics state={summary} filters={filters} copy={copy} />
      <WorkflowCatalog key={`${organization.id}:${connection.tenant}`} state={tenant} copy={copy} organizationId={organization.id} tenant={connection.tenant}
        filters={filters} revision={catalogRevision} workers={props.execution_workers ?? []} />
      <ExecutionTable state={executions} filters={filters} path={list_path} workflows={tenant?.data?.workflows ?? []} copy={copy} />
      <ExecutionLookup key={organization.id} query={query_execution_id} error={null} copy={copy} />
      {tenant?.data && <TemporalPanel status={tenant.data} url={temporal_url} copy={copy} />}
    </>}
  </main>
}
Index.layout = (page: React.ReactElement) => <DashboardLayout>{page}</DashboardLayout>
export default Index
